<script setup></script>

<template>
  <svg width="100%" height="100%" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.4235 0.248096C36.8777 0.578264 37.0635 1.01849 36.9809 1.56877L31.6957 33.265C31.6269 33.6639 31.4067 33.9735 31.035 34.1936C30.8424 34.3036 30.629 34.3587 30.395 34.3587C30.2436 34.3587 30.0785 34.3243 29.8995 34.2555L19.0194 29.8188L12.867 36.5667C12.6193 36.8556 12.2958 37 11.8967 37C11.704 37 11.5457 36.9725 11.4218 36.9175C11.1603 36.8212 10.9539 36.6595 10.8025 36.4325C10.6511 36.2055 10.5754 35.9545 10.5754 35.6793V26.3521L0.830709 22.3694C0.321454 22.1768 0.0461807 21.7985 0.00488972 21.2344C-0.0364012 20.6979 0.183817 20.2921 0.665545 20.0169L35.0196 0.206824C35.5014 -0.0820732 35.9693 -0.0683162 36.4235 0.248096ZM29.3628 31.1808L33.9254 3.87995L4.31979 20.9455L11.2567 23.7726L29.0737 10.5865L19.2052 27.033L29.3628 31.1808Z"
      fill="white"
    />
  </svg>
</template>
